import script from "./FreeShipping.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreeShipping.vue?vue&type=script&lang=ts&setup=true"

import "./FreeShipping.vue?vue&type=style&index=0&id=fbc2e6f4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbc2e6f4"]])

export default __exports__